<template>
  <div id="filter-modal" class="mt-4">
    <v-row class="mx-9">
      <v-autocomplete
        clearable
        filled
        label="City"
        class="pt-0"
        dense
        id="filter-city"
        :items="_filterOptions.cities"
        color="secondary"
        v-model="filterParams.location"
      ></v-autocomplete>
    </v-row>
    <v-row class="mx-9">
      <v-autocomplete
        clearable
        filled
        :label="groupLabel"
        id="filter-group"
        dense
        :items="_filterOptions.groups"
        color="secondary"
        v-model="filterParams.group"
      ></v-autocomplete>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [FilterParams],
  computed: {
    ...mapGetters({
      _filterOptions: 'filters/getDevicesFilterOptions',
      _userGroups: 'account/getUserGroups',
      _client: 'account/getCurrentClient',
    }),
    groupLabel() {
      if (this._client.client_name != 'shark') {
        return 'Group Name';
      }
      return 'Course Name';
    },
  },
};
</script>

<style></style>
